import { scrollIntoViewWithOffset } from '@/utils/Common/Utils';

class PaperlessNavController {
  constructor() {
    this.nav = document.querySelector('.js-dln-paperless-nav');
    this.navWrapper = document.querySelector('.js-dln-paperless-nav-wrapper');
    this.navLinks = document.querySelectorAll('.js-dln-paperless-nav-link');
    this.navLinkTargetClass = 'js-dln-paperless-id-';
    this.navLinkActiveClass = '--active';
    this.navLinkHiddenClass = '--hidden';
    this.observerEntries = document.querySelectorAll(
      '.js-dln-paperless-observer-entry',
    );
  }

  revealNavLinks() {
    this.navLinks.forEach(link => {
      const observerEntry = [...this.observerEntries].find(entry =>
        entry.className.includes(
          `${this.navLinkTargetClass}${link.hash.replace('#', '')}`,
        ),
      );

      if (observerEntry) {
        link.classList.remove(this.navLinkHiddenClass);
      }
    });
  }

  bindNavScroll() {
    const callback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const entryClass = [...entry.target.classList]
            .find(className => className.startsWith(this.navLinkTargetClass))
            .replace(`${this.navLinkTargetClass}`, '');
          const navLink = document.querySelector(
            `.js-dln-paperless-nav-link[href="#${entryClass}"]`,
          );
          if (!navLink) return;
          this.navLinks.forEach(link =>
            link.classList.remove(this.navLinkActiveClass),
          );
          navLink.classList.add(this.navLinkActiveClass);

          if (window.innerWidth < 1440) {
            this.navWrapper.scrollBy({
              left: navLink.offsetLeft - this.navWrapper.scrollLeft - 20,
              behavior: 'smooth',
            });
          }
        }
      });
    };

    const navObserver = new IntersectionObserver(callback, {
      threshold: 0.9,
    });

    this.observerEntries.forEach(entry => {
      navObserver.observe(entry);
    });
  }

  bindNavLinkClick() {
    this.navLinks.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const selector = `.${this.navLinkTargetClass}${e.target.hash.replace(
          '#',
          '',
        )}`;
        scrollIntoViewWithOffset(selector, 80);
      });
    });
  }

  init() {
    if (this.nav) {
      this.revealNavLinks();
      this.bindNavScroll();
      this.bindNavLinkClick();
    }
  }
}

export const paperlessNavController = new PaperlessNavController();
export default paperlessNavController;
